import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const loc = useLocation();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/customer/login", f);
      login(data.token, data.customer);
      toast.success(`Welcome back, ${data.customer.name.split(" ")[0]}.`);
      nav(loc.state?.from || "/account");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed.");
    } finally { setBusy(false); }
  };
  return (
    <div className="text-white max-w-md mx-auto px-6 py-20">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">My Account</p>
      <h1 className="font-display text-4xl md:text-5xl">Sign in.</h1>
      <p className="mt-3 text-white/60 text-sm">Track orders, manage products, unlock birthday benefits.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input data-testid="login-email" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="bg-white/5 border-white/10" />
        <Input data-testid="login-password" type="password" placeholder="Password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="bg-white/5 border-white/10" />
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-[#00B5D8] hover:bg-[#009AB8] text-black font-bold rounded-full py-6">{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
      <p className="mt-6 text-sm text-white/60">No account yet? <Link to="/register" className="text-[#00B5D8] hover:underline">Create one</Link></p>
    </div>
  );
}
